export default "__VITE_ASSET__C9BdMMyO__"